// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__TF0Yb"};